<template>
  <generic-modal :title="$t('template')" ref="generic_modal">
    <form>
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("name") }}</label>
            <div class="control">
              <input
                type="text"
                class="input"
                v-model="meta.name"
                :placeholder="$t('name')"
              />
            </div>
          </div>
        </div>
        <div class="column is-4">
          <div class="field">
            <label class="label">{{ $t("language") }}</label>
            <div class="control">
              <div class="select is-fullwidth">
                <select v-model="meta.settings.language">
                  <option value="en_US">{{ $t("english (us)") }}</option>
                  <option value="es">{{ $t("spanish") }}</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="field">
        <label class="label">{{ $t("message") }}</label>
        <textarea
          class="textarea"
          v-model="meta.settings.message"
          rows="4"
        ></textarea>
      </div>
    </form>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  post,
  get,
  change_active_tab,
  generate_error_message_text,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";

export default {
  name: "TemplateModal",
  components: { GenericModal },
  props: {},
  data() {
    return {
      meta: { settings: {} },
      error: "",
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return !v.meta.name || !v.meta.settings.message;
    },
  },
  methods: {
    close_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.close_modal();
    },
    show_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.show_modal();
    },
    edit_modal(template_uuid) {
      let v = this;
      v.set_initial_state();
      get("/whatsapp/template", { uuid: template_uuid })
        .then((template) => {
          v.meta = template;
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
      v.$refs.generic_modal.show_modal();
    },
    save() {
      let v = this;
      let template = { ...v.meta };
      if (template.uuid) {
        post("/whatsapp/template", template)
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          })
          .finally(() => {});
      } else {
        put("/whatsapp/template", template)
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          })
          .finally(() => {});
      }
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        name: "",
        settings: {},
      };
      v.error = "";
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
